
import listArrange from '@/components/temporary/list-arrange'
import listHeader from '@/components/temporary/list-header'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
import Badge from 'vux/src/components/badge/index.vue'


export default {
name: "asn-needTP",
data() {
return {
listHeaderTemplateBoard: {},
listArrange: [],
approvalTemplateBoard: {}
}
},
props: ['data'],
created() {
let templateData = this.data;
templateData.matName=templateData.matName||templateData.material.matName
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.contractQueryV2,
data() {
return {
title: [templateData.matName],
desc:[templateData.supplierName,templateData.purorgName]
}
}
},
this.listArrange = [
{
icon: "fa fa-file-marketing-o font-size-mr",
span: 24,
templateBoard: {
template: "<span style=\"font-size: .9rem;\">{{maxQty}}&nbsp;{{planCount}}/{{confirmCount}}</span>",

data() {
return {
maxQty: templateData.maxQty,
planCount: templateData.planCount,
confirmCount: templateData.confirmCount,
}
},
components:{
divSpan
}
}
},
{
icon: "fa fa-file-text-o font-size-mr",
templateBoard: {
template: "<span style=\"font-size: .75rem;\">{{orderNo}}</span>",
data() {
return {
orderNo: templateData.orderNo,
}
},
},
span: 24
},
]
},
methods: {},
components: {
listArrange,
divSpan,
listHeaderTemplate,
listHeader
}
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/asn-needTP.vue